import React from 'react'; // eslint-disable-line
import App from './modules/App';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import store, { history } from './redux/store';
import * as Sentry from '@sentry/react';
import 'toastr/build/toastr.min.css';
import './images/favicon.png';
import './theme/styles/style.less';
import { loadEnvConfig } from './utils/ConfigUtils';

const target = document.querySelector('#root');

// Load env.json configuration BEFORE rendering
// This ensures BACKEND_URL is loaded before any API calls
loadEnvConfig()
  .then(() => {
    console.log('✅ env.json loaded, BACKEND_URL is ready');
    renderApp();
  })
  .catch((error) => {
    console.warn('Failed to load env.json configuration:', error);
    renderApp();
  });

function renderApp() {
  // eslint-disable-next-line no-undef
  window.Intk && window.Intk('initOnSiteMessaging');

  if (window.location.host === 'dash.intrack.ir') {
    Sentry.init({
      dsn: 'https://867f93e27aec085e931060bcb39354cf@sentry.devops.smartech.ir/20',
      environment: 'production',
      integrations: [
        new Sentry.BrowserTracing({
          routingInstrumentation: Sentry.reactRouterV4Instrumentation(history),
        }),
        new Sentry.Replay({
          maskAllText: true,
          blockAllMedia: true,
        }),
      ],
      tracesSampleRate: 0.1,
      replaysSessionSampleRate: 0.05,
      replaysOnErrorSampleRate: 1.0,
    });
  }

  render(
    <Provider store={store}>
      <ConnectedRouter history={history}>
        {/* eslint-disable-next-line react/no-unescaped-entities, no-undef */}
        {/* {window.Intk && window.Intk('initOnSiteMessaging')} */}
        <App />
      </ConnectedRouter>
    </Provider>,
    target
  );
}
if (process.env.NODE_ENV === 'development') {
  // eslint-disable-next-line no-undef
  module.hot.accept();
}
